<template>
  <div class="checker-results">
    <div class="full">
      <h3>Registration Number</h3>
      <div>{{ registrationNumber }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
     <h3>Approved Length</h3>
      <div>{{ approvedLength }}</div>
    </div>
    <div class="half">
      <h3>Expiry Date</h3>
      <div>{{ expiryDate }}</div>
    </div>
    <div class="gap"></div>
    <div class="half">
      <h3>Location</h3>
      <div>{{ location }}</div>
    </div>
    <div class="half">
      <h3>Location 2</h3>
      <div>{{ location2 }}</div>
    </div>
    <div class="half">
      <h3>Location 3</h3>
      <div>{{ location3 }}</div>
    </div>
    <div class="half">
      <h3>Location 4</h3>
      <div>{{ location4 }}</div>
    </div>
    <div class="gap"></div>
    <div class="full mooring-position">
      <div class="half">
        <h3>Latitude</h3>
        <div>{{ position.latitude }}</div>
      </div>
      <div class="half">
        <h3>Longitude</h3>
        <div>{{ position.longitude }}</div>
      </div>
    </div>
    <div class="gap"></div>
    <div class="full">
      <h3>Transferable</h3>
      <div>{{ transferable }}</div>
    </div>
  </div>
</template>
<script>
import { date, sentence, title, metres } from '@/filters'
export default {
  props: {
    item: { type: Object, default: () => {} }
  },
  computed: {
    registrationNumber () { return this.item.mo_rego_no },
    expiryDate () { return date(this.item.mo_expiry_date) },
    approvedLength () { return metres(this.item.mo_len_approv) },
    location () { return title(this.item.mo_location_1) },
    location2 () { return sentence(this.item.mo_location_2) },
    location3 () { return sentence(this.item.mo_location_3) },
    location4 () { return sentence(this.item.mo_location_4) },
    position () {
      return {
        latitude: this.item.mo_ddm_latitude,
        longitude: this.item.mo_ddm_longitude
      }
    },
    transferable () { return this.item.mo_transferable }
  },
  mounted () {
    if (window.__gaTracker) {
      window.__gaTracker('send', 'event', 'Licence Checker', 'Mooring Registration Check')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mooring-results.vue